module.exports = __webpack_public_path__ + "static/img/time_2.080cbee0.webp";